import { Modal as MModal } from '@mantine/core';
import { MODAL_SIZE_DEFAULT } from '@shared/ui/modal';
import classes from './modal.module.scss';

export const Modal = MModal.extend({
  defaultProps: {
    size: MODAL_SIZE_DEFAULT,
    classNames: classes,
    closeButtonProps: {
      size: 'md',
    },
    centered: true,
  },
});
